<template>
    <div class="tips-wrap">
        <van-list
            v-model="bLoading"
            :finished="bFinished"
            finished-text="没有更多了"
            :immediate-check="false"
            @load="touchBottom"
        >
            <div class="tips-item" v-for="(item,index) in arrTips" :key="index">
                <div class="peoper-wrap">
                    <div class="left">
                        <div class="head-img">
                            <!--<img src="" alt="">-->
                            <img :src="item.headimgurl" alt="">
                        </div>
                        <div class="info">
                            <div class="name">{{ item.nickname }}</div>
                            <div class="date">时间：{{ item.date }}</div>
                        </div>
                    </div>
                    <div class="right">时长:{{ item.time }}{{ item.time_type == 'm' ? 'min' : 's' }}</div>
                </div>
                <div class="from-item from-item-t">
                    <div class="title">页面:</div>
                    <div class="name">{{ item.type_desc }}</div>
                </div>
                <div class="from-item">
                    <div class="title">案例:</div>
                    <div class="name">{{ item.title }}</div>
                </div>
            </div>
        </van-list>
    </div>
</template>
<script>
import oStorage from '@/libsV2/storage.js'
import {getPlanTipsList} from "@/js/project/v3";

getPlanTipsList
export default {
    name: 'tips',
    data() {
        return {
            bLoading: false,
            bFinished: false,
            objParams: {
                page: 0,
                limit: 10
            },
            arrTips: []
        }
    },
    created() {
        this.userId = this.$route.query.user_id || 0;
        if (!this.userId) {
            this.$toast({
                message: '用户ID有误',
                duration: 800,
            });
        } else {
            this.objParams = {
                page: 0,
                limit: 10
            };
            this.arrTips = [];
            this.getTipsList()
        }
    },
    methods: {
        touchBottom() {
            this.bLoading = true
            console.log('触发触底')
            this.$set(this.objParams, 'page', this.objParams.page + 1)
            this.getTipsList().then(res => {
                this.bLoading = false
            })
        },
        async getTipsList() {
            await getPlanTipsList({...this.objParams, see_user_id: this.userId, user_id: this.userId}).then(res => {
                console.log(res, 'res')
                if (res.result.length < this.objParams.limit) {
                    this.bFinished = true
                }
                // this.arrTips = this.arrTips.concat(res.result)
                this.arrTips.push(...res.result);
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.tips-wrap {
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    background: #F5F6F7;
    align-items: center;
    padding: 24px 0;

    .tips-item {
        margin: 0 auto 28px;
        width: 702px;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px 0px rgba(92, 119, 241, 0.12);
        border-radius: 20px;
        overflow: hidden;

        .peoper-wrap {
            width: 100%;
            height: 136px;
            background: #5C77F1;
            border-radius: 20px;
            padding: 24px 28px 0 28px;
            display: flex;
            justify-content: space-between;

            .left {
                display: flex;

                .head-img {
                    width: 88px;
                    height: 88px;
                    border-radius: 50%;
                    background: #fff;

                    img {
                        width: 88px;
                        height: 88px;
                        border-radius: 50%;
                    }
                }

                .info {
                    padding-left: 16px;

                    .name {
                        font-size: 28px;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 40px;
                    }

                    .date {
                        margin-top: 10px;
                        font-size: 28px;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.6);
                        line-height: 40px;
                    }
                }
            }

            .right {
                font-size: 24px;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.6);
                line-height: 34px;
            }
        }

        .from-item {
            width: calc(100% - 56px);
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 26px;

            .title {
                min-width: 100px;
                font-size: 28px;
                font-weight: 400;
                color: #7A7A7A;
            }

            .name {
                font-size: 28px;
                font-weight: 400;
                color: #222222;
            }
        }

        .from-item-t {
            border-bottom: 1px solid rgba(92, 119, 241, 0.12);
        }
    }
}
</style>
